import { Epic } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { TrackEvent } from '@alycecom/services';
import { ofType } from '@alycecom/utils';

import { declineGiftRequest, declineGiftSuccess, declineGiftFail } from './decline.actions';

export const declineGiftEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(declineGiftRequest),
    mergeMap(({ payload: { hashId, reason, product } }) =>
      apiService.post(`/api/recipient/${hashId}/decline`, { body: { feedback: reason, reason } }).pipe(
        mergeMap(() => [
          TrackEvent.actions.trackEvent({ name: 'Gift invitation - Declined', payload: { hashId, reason, product } }),
          declineGiftSuccess(),
        ]),
        catchError(errorHandler({ callbacks: declineGiftFail })),
      ),
    ),
  );

export const declineEpics = [declineGiftEpic];
